module.exports = __webpack_public_path__ + "img/af5ce29a74c15a76bd217f8cfe4a9b78.png";